import { createContext } from 'react';

export type ToastContextValue = {
  hidden: boolean;
};

export const ToastContext = createContext<ToastContextValue | null>(null);
